import React, { useState } from 'react';
import './About.css';
// import Kritika from "./Images/Kritika1.jpg";
// import Neeraj from "./Images/Neeraj.jpg";
// import Komal from "./Images/Komal.jpg"
// import Manisha from "./Images/Manisha.jpg";
import Mittal from "./Images/Mittal.jpg";
// import Binshu from "./Images/Binshu.jpg";
import Arika from "./Images/Arika.jpeg";

// import Sunil from "./Images/Sunil.jpeg";

import Manish from "./Images/Manish.jpg";
import Monty from "../src/Images/montysir.png";
import img1 from "./Images/About.jpg";
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaInstagram, FaArrowRight } from 'react-icons/fa';

const WhoWeAre = () => {
    const [activeTab, setActiveTab] = useState('story');

    // Team members data with individual social links
    const teamMembers = [
        {
            id: 1,
            name: "Monty Tiwari (Monty Baba)",
            email: "montytiwari@gmail.com",
            role: "Founder & CEO",
            img: Monty,
            bio: "Founder & CEO with 25+ years of expertise in industrial, commercial, and domestic real estate.",
            social: {
                facebook: "https://www.facebook.com/monty.baba.30973",
                instagram: "https://www.instagram.com/montybaba47?igsh=MXNwdWwzN2JmODNuNg=="
            }
        },
        {
            id: 2,
            name: "Manish Pandey",
            role: "Web & IT Administrator",
            email: "manishpandey849095@gmail.com",
            img: Manish,
            bio: "Web & IT Administrator specializing in digital marketing and online property solutions.",
            social: {
                linkedin: "https://www.linkedin.com/in/manish-pandey-27b19b265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                facebook: "https://www.facebook.com/share/17wK9Lpd6G/",
                instagram: "https://www.instagram.com/manishkumarpandey885?igsh=cnd5OTB2ampvNWZv"
            }
        },
        {
            id: 3,
            name: "Mittal Vashi",
            role: "HR & Business Development Executive",
            email: "hr@bgrealestate360.com",
            img: Mittal,
            bio: " HR & Business Development Executive driving talent acquisition and client growth.",
            social: {
                linkedin: "https://www.linkedin.com/feed/",
                facebook: "https://www.facebook.com/profile.php?id=61585309266874",
                twitter: " ",
                instagram: "https://www.instagram.com/bgrealstate360"
            }
        },
        // {
        //     id: 4,
        //     name: "Sunil Shrivastav",
        //     role: "Sales & Marketing Manager",
        //     email: "bgrealstate360@gmail.com",
        //     img: Sunil,
        //     bio: "Sales & Marketing Manager is responsible for driving sales growth and strengthening brand presence. The role focuses on sales strategy, marketing planning, lead generation, and client relationship management to achieve business goals efficiently.",
        //     social: {
        //         linkedin: "https://www.linkedin.com/feed/",
        //         facebook: "https://www.facebook.com/profile.php?id=61585309266874",
        //         twitter: " ",
        //         instagram: "https://www.instagram.com/bgrealstate360"
        //     }
        // }


        {
            id: 5,
            name: "Rani Dubey",
            role: "CRM Executive /  Digital Marketing",
            email: "bgrealstate360@gmail.com",
            img: Arika,
            bio: "I am dedicated to managing customer relationships efficiently by ensuring smooth communication, timely support, and a professional experience that helps build long-term trust and customer satisfaction.",
            social: {
                linkedin: "https://www.linkedin.com/feed/",
                facebook: "https://www.facebook.com/profile.php?id=61585309266874",
                twitter: " ",
                instagram: "https://www.instagram.com/bgrealstate360"
            }
        },



        // {
        //     id: 6,
        //     name: "Manisha Rathava",
        //     role: "Sales Executive",
        //     email: "bgrealstate360@gmail.com",
        //     img: Manisha,
        //     bio: " I believe customer satisfaction is the key to success, and I always strive to provide a smooth, trustworthy, and professional experience to every client.",
        //     social: {
        //         linkedin: "https://www.linkedin.com/feed/",
        //         facebook: "https://www.facebook.com/profile.php?id=61585309266874",
        //         twitter: " ",
        //         instagram: "https://www.instagram.com/bgrealstate360"
        //     }
        // },
        // {
        //     id: 4,
        //     name: "Komal Rathore",
        //     role: "Sales Executive",
        //     email: "bgrealstate360@gmail.com",
        //     img: Komal,
        //     bio: " I am committed to understanding customer requirements and providing the most suitable solutions with professionalism, transparency, and dedicated support.",
        //     social: {
        //         linkedin: "https://www.linkedin.com/feed/",
        //         facebook: "https://www.facebook.com/profile.php?id=61585309266874",
        //         twitter: " ",
        //         instagram: "https://www.instagram.com/bgrealstate360"
        //     }
        // },



        // {
        //     id: 7,
        //     name: "Binshu Ahir",
        //     role: "Sales Executive",
        //     email: "bgrealstate360@gmail.com",
        //     img: Binshu,
        //     bio: " My focus is to build long-term relationships with customers by delivering excellent service, clear communication, and reliable business solutions",
        //     social: {
        //         linkedin: "https://www.linkedin.com/feed/",
        //         facebook: "https://www.facebook.com/profile.php?id=61585309266874",
        //         twitter: " ",
        //         instagram: "https://www.instagram.com/bgrealstate360"
        //     }
        // },




    ];

    // Tab content data
    const tabContent = {
        story: {
            title: "Our Story",
            description: "BG RealEstate360 started its journey in 2001 as a traditional offline real estate business. With decades of hands-on experience in industrial, commercial, and domestic properties, we built strong client relationships based on trust and transparency. Today, we have transformed into a digital-first real estate company, making property buying and selling faster, smarter, and more reliable.",
            highlights: [
                "Established in 2001 with strong offline roots",
                "25+ years of real estate expertise",
                "Specialized in industrial, commercial & domestic properties",
                "Successfully transitioned to a digital real estate platform"
            ],
            stats: [
                { number: "25+", label: "Years Experience" },
                { number: "1000+", label: "Properties Managed" },
                { number: "98%", label: "Client Satisfaction" },
                { number: "360°", label: "Complete Solutions" }
            ],
            images: [
                {
                    src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
                    alt: "Our team collaborating in a modern office environment",
                    tag: "Team Collaboration",
                    title: "Innovating Together"
                },
                {
                    src: img1,
                    alt: "Our company building and infrastructure",
                    tag: "Our Heritage",
                    title: "Since 2001"
                }
            ]
        },
        mission: {
            title: "Our Mission",
            description: "Our mission is to provide transparent, reliable, and end-to-end real estate solutions for industrial, commercial, and domestic properties. By combining market knowledge with digital innovation, we aim to simplify transactions and help clients make confident property decisions.",
            highlights: [
                "Transparent and ethical transactions",
                "Client-focused property solutions",
                "Technology-driven real estate services",
                "Long-term value creation"
            ],
            stats: [
                { number: "100%", label: "Transparency" },
                { number: "24/7", label: "Client Support" },
                { number: "95%", label: "Successful Closures" },
                { number: "25+", label: "Years of Expertise" }
            ],
            images: [
                {
                    src: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
                    alt: "Our team discussing project plans",
                    tag: "Client Focus",
                    title: "Building Trust"
                },
                {
                    src: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
                    alt: "Digital transformation in real estate",
                    tag: "Innovation",
                    title: "Digital Solutions"
                }
            ]
        },
        values: {
            title: "Our Vision",
            description: "Our vision is to become a trusted digital real estate brand in India, known for integrity, expertise, and customer confidence. We strive to set new benchmarks in industrial and commercial real estate by blending experience with modern technology.",
            highlights: [
                "Trusted digital real estate brand",
                "Strong client relationships",
                "Innovation backed by experience",
                "Sustainable long-term growth"
            ],
            stats: [
                { number: "2001", label: "Established" },
                { number: "99%", label: "Client Retention" },
                { number: "4.8/5", label: "Client Rating" },
                { number: "100+", label: "Active Listings" }
            ],
            images: [
                {
                    src: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
                    alt: "Future vision and growth planning",
                    tag: "Future Ready",
                    title: "Growing Together"
                },
                {
                    src: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
                    alt: "Team celebrating success",
                    tag: "Success",
                    title: "Achieving Milestones"
                }
            ]
        }
    };

    // Handle social link click
    const handleSocialClick = (url, platform, memberName, event) => {
        event.preventDefault();
        event.stopPropagation();
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    // Handle CTA button click
    const handleCTAClick = () => {
        const aboutSection = document.getElementById('about-page');
        if (aboutSection) {
            aboutSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.location.href = '/about';
        }
    };

    return (
        <section className="who-we-are-section" id="about">
            <div className="wwa-container">

                {/* Section Header */}
                <div className="wwa-header">
                    <span className="wwa-subtitle">About Our Company</span>
                    <h2 className="wwa-title">Who We Are</h2>
                    <p className="wwa-description">
                        A team of passionate innovators, creators, and problem-solvers dedicated to delivering exceptional digital experiences that drive business growth.
                    </p>
                </div>

                {/* Interactive Tabs */}
                <div className="wwa-tabs">
                    {Object.keys(tabContent).map((tab) => (
                        <button
                            key={tab}
                            className={`wwa-tab-btn ${activeTab === tab ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab)}
                            aria-label={`Show ${tabContent[tab].title} content`}
                            aria-expanded={activeTab === tab}
                        >
                            {tabContent[tab].title}
                        </button>
                    ))}
                </div>

                {/* Tab Content - UPDATED FOR 2 IMAGES */}
                <div className="wwa-content">
                    <div className="wwa-text-content">
                        <h3 className="wwa-content-title">{tabContent[activeTab].title}</h3>
                        <p className="wwa-content-description">{tabContent[activeTab].description}</p>

                        <div className="wwa-highlights">
                            {tabContent[activeTab].highlights.map((item, index) => (
                                <div key={index} className="highlight-item">
                                    <span className="highlight-icon">✓</span>
                                    <span className="highlight-text">{item}</span>
                                </div>
                            ))}
                        </div>

                        <div className="wwa-stats">
                            {tabContent[activeTab].stats.map((stat, index) => (
                                <div key={index} className="stat-card">
                                    <div className="stat-number">{stat.number}</div>
                                    <div className="stat-label">{stat.label}</div>
                                </div>
                            ))}
                        </div>

                        <button
                            className="wwa-cta-btn"
                            onClick={handleCTAClick}
                            aria-label="Learn more about our company"
                        >
                            Discover Our Full Story
                            <span className="arrow"><FaArrowRight /></span>
                        </button>
                    </div>

                    {/* UPDATED: Now showing 2 images */}
                    <div className="wwa-image-content">
                        {/* First Image */}
                        <div className="wwa-main-image">
                            <img
                                src={tabContent[activeTab].images[0].src}
                                alt={tabContent[activeTab].images[0].alt}
                                loading="lazy"
                            />
                            <div className="image-overlay">
                                <div className="overlay-text">
                                    <span className="overlay-tag">{tabContent[activeTab].images[0].tag}</span>
                                    <h4 className="overlay-title">{tabContent[activeTab].images[0].title}</h4>
                                </div>
                            </div>
                        </div>

                        {/* Second Image */}
                        <div className="wwa-secondary-image">
                            <img
                                src={tabContent[activeTab].images[1].src}
                                alt={tabContent[activeTab].images[1].alt}
                                loading="lazy"
                            />
                            <div className="image-overlay">
                                <div className="overlay-text">
                                    <span className="overlay-tag">{tabContent[activeTab].images[1].tag}</span>
                                    <h4 className="overlay-title">{tabContent[activeTab].images[1].title}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Meet Our Team Section */}
                <div className="wwa-team-section">
                    <h3 className="team-title">Meet Our Leadership Team</h3>
                    <p className="team-subtitle">
                        The talented individuals who lead our company with vision, expertise, and dedication
                    </p>

                    <div className="team-grid">
                        {teamMembers.map((member) => (
                            <div key={member.id} className="team-card">
                                <div className="team-img-container">
                                    <img
                                        src={member.img}
                                        alt={`${member.name}, ${member.role}`}
                                        className="team-img"
                                        loading="lazy"
                                    />
                                    <div className="team-overlay">
                                        <div className="social-icons">
                                            {member.social.linkedin && (
                                                <button
                                                    className="social-icon linkedin"
                                                    onClick={(e) => handleSocialClick(
                                                        member.social.linkedin,
                                                        'LinkedIn',
                                                        member.name,
                                                        e
                                                    )}
                                                    aria-label={`Connect with ${member.name} on LinkedIn`}
                                                    title={`${member.name}'s LinkedIn Profile`}
                                                >
                                                    <FaLinkedinIn />
                                                </button>
                                            )}

                                            {member.social.facebook && (
                                                <button
                                                    className="social-icon facebook"
                                                    onClick={(e) => handleSocialClick(
                                                        member.social.facebook,
                                                        'Facebook',
                                                        member.name,
                                                        e
                                                    )}
                                                    aria-label={`Connect with ${member.name} on Facebook`}
                                                    title={`${member.name}'s Facebook Profile`}
                                                >
                                                    <FaFacebookF />
                                                </button>
                                            )}

                                            {member.social.twitter && (
                                                <button
                                                    className="social-icon twitter"
                                                    onClick={(e) => handleSocialClick(
                                                        member.social.twitter,
                                                        'Twitter',
                                                        member.name,
                                                        e
                                                    )}
                                                    aria-label={`Follow ${member.name} on Twitter`}
                                                    title={`${member.name}'s Twitter Profile`}
                                                >
                                                    <FaTwitter />
                                                </button>
                                            )}

                                            {member.social.instagram && (
                                                <button
                                                    className="social-icon instagram"
                                                    onClick={(e) => handleSocialClick(
                                                        member.social.instagram,
                                                        'Instagram',
                                                        member.name,
                                                        e
                                                    )}
                                                    aria-label={`Follow ${member.name} on Instagram`}
                                                    title={`${member.name}'s Instagram Profile`}
                                                >
                                                    <FaInstagram />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4 className="team-member-name">{member.name}</h4>
                                    <p className="team-member-role">{member.role}</p>
                                    <p className="team-member-bio">{member.bio}</p>

                                    <div className="visible-social-links">
                                        <small className="social-hint">Connect with {member.name.split(' ')[0]}:</small>
                                        <div className="social-badges">
                                            {member.social.linkedin && (
                                                <button
                                                    className="social-badge linkedin"
                                                    onClick={(e) => handleSocialClick(member.social.linkedin, 'LinkedIn', member.name, e)}
                                                    aria-label={`Open ${member.name}'s LinkedIn profile`}
                                                >
                                                    LinkedIn
                                                </button>
                                            )}
                                            {member.social.facebook && (
                                                <button
                                                    className="social-badge facebook"
                                                    onClick={(e) => handleSocialClick(member.social.facebook, 'Facebook', member.name, e)}
                                                    aria-label={`Open ${member.name}'s Facebook profile`}
                                                >
                                                    Facebook
                                                </button>
                                            )}
                                            <button
                                                className="social-badge email"
                                                onClick={() => window.location.href = `mailto:${member.email}`}
                                                aria-label={`Email ${member.email}`}
                                            >
                                                Email
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Team CTA */}
                    <div className="team-cta">
                        <p className="cta-text">Want to join our amazing team?</p>
                        <button
                            className="team-cta-btn"
                            onClick={() => window.open('/careers', '_blank')}
                            aria-label="View career opportunities"
                        >
                            View Career Opportunities
                            <FaArrowRight style={{ marginLeft: '8px' }} />
                        </button>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default WhoWeAre;